import * as React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';

const Main = () => {
  const store = useStore(() => new MainStore());
  let styles = '';

  if (!store.isMobile) {
    styles = require('./index.less');
  } else {
    styles = require('./mo.less');
  }

  return (
    <Page className={cx(styles.root)}>
      <div className={styles.container}>
        <h2 className={cx(styles.title)}>{store?.article_title}</h2>
        <div className={styles.content} onClick={store.handleImageClick} dangerouslySetInnerHTML={{ __html: store?.content }} />
      </div>
      {/* 图片全屏预览遮罩层，仅移动端点击图片后显示 */}
      {store.previewVisible && (
        <div
          className={styles.previewMask}
          onClick={store.closePreview}
          onTouchStart={store.pinchZoomHandler.touchStart}
          onTouchMove={store.pinchZoomHandler.touchMove}
          onTouchEnd={store.pinchZoomHandler.touchEnd}
        >
          <img className={styles.previewImg} src={store.previewSrc} alt="" style={{ transform: store.previewTransform }} />
        </div>
      )}
    </Page>
  );
};

export default observer(Main);
